<template>
    <div class="module">
        <div class="header-sticky" :class="{ mobile: isMobile }">
            <div v-if="moduleDataLoaded" class="backroute-module" @click.stop="router.replace(`/course/${route.params.courseId}`)"><i class="material-icons">arrow_back</i><span>{{ $t('module.actions.BACK_TO_COURSE_START') }}</span></div>
            <div class="module__header" v-if="moduleDataLoaded && !isMobile ">
                <button :disabled="!moduleData.prevModuleId"
                    @click.stop="router.push(`/course/${route.params.courseId}/module/${moduleData.prevModuleId}`)">
                    <i class="material-icons">chevron_left</i> {{ $t('module.actions.PREVIOUS') }}
                </button>
                <div>
                    <small>{{$t('global.UNIT')}} {{moduleData.unitOrderNumber}}: {{moduleData.unitName}}</small>
                    <h2>{{moduleData.name}}</h2>
                </div>
                <button :disabled="!moduleData.nextModuleId && moduleData.courseType != 1"
                    @click.stop="router.push(
                        moduleData.isLastModule 
                            ? `/course/${route.params.courseId}/courseEnd`
                            : `/course/${route.params.courseId}/module/${moduleData.nextModuleId}`
                        )"
                >
                    {{ moduleData.isLastModule ? $t('module.actions.FINISH') : $t('module.actions.NEXT') }} <i class="material-icons">chevron_right</i>
                </button>
            </div>
            <div v-else-if="moduleDataLoaded && isMobile" class="module__header">
                <div class="previewNext">
                    <button :disabled="!moduleData.prevModuleId"
                        @click.stop="router.push(`/course/${route.params.courseId}/module/${moduleData.prevModuleId}`)">
                        <i class="material-icons">chevron_left</i> Anterior
                    </button>
                    <button :disabled="!moduleData.nextModuleId && moduleData.courseType != 1"
                        @click.stop="router.push(
                        moduleData.isLastModule 
                            ? `/course/${route.params.courseId}/courseEnd`
                            : `/course/${route.params.courseId}/module/${moduleData.nextModuleId}`
                        )"
                    >
                        {{ $t('module.actions.NEXT') }}  <i class="material-icons">chevron_right</i>
                    </button>
                </div>
                <div>
                    <h2>{{moduleData.name}}</h2>
                    <small>{{$t('global.UNIT')}} {{moduleData.unitOrderNumber}}: {{moduleData.unitName}}</small>
                </div>
            </div>
        </div>
        <div class="module__resume" v-if="moduleDataLoaded">
            <div v-if="moduleData.moduleHeader.firstTextValue"><i class="material-icons">playlist_add_check</i><span>{{moduleData.moduleHeader.firstItemValue}}</span> {{$t(`module.resume.${moduleData.moduleHeader.firstTextValue}`)}}</div>
            <div v-if="moduleData.moduleHeader.secondTextValue"><i class="material-icons">playlist_add_check</i><span>{{moduleData.moduleHeader.secondItemValue}}</span> {{$t(`module.resume.${moduleData.moduleHeader.secondTextValue}`)}}</div>
            <div v-if="moduleData.moduleHeader.thirdTextValue"><i class="material-icons">playlist_add_check</i><span>{{moduleData.moduleHeader.thirdItemValue}}</span> {{$t(`module.resume.${moduleData.moduleHeader.thirdTextValue}`)}}</div>
            <div v-if="moduleData.moduleHeader.fourthTextValue"><i class="material-icons">playlist_add_check</i><span>{{moduleData.moduleHeader.fourthItemValue}}</span> {{$t(`module.resume.${moduleData.moduleHeader.fourthTextValue}`)}}</div>
        </div>

        <render-module 
            :moduleId="route.params.moduleId" 
            :courseId="route.params.courseId" 
            :editMode="false" 
            @dataLoaded="(data) => { moduleData=data; moduleDataLoaded=true }" 
        />
    </div>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import { onMounted, ref } from 'vue';
// import EmptyState from '../components/EmptyState.vue';
import RenderModule from '@/views/Contents/RenderModule.vue';


const router = useRouter();
const route = useRoute();
const moduleDataLoaded = ref(false);
const moduleData = ref();
// const moduleLocked = ref(false);
// const moduleLockedDate = ref(null);
const isMobile = ref(false);

/* watch(()=>route.params.moduleId,()=>{
    if(route.params.moduleId) getModule(route.params.moduleId);
}) */

onMounted(()=>{
    isMobile.value = window.innerWidth < 1000
    window.addEventListener('resize', () => isMobile.value = window.innerWidth < 1000 )
})


</script>

<style lang="scss">
@import '@/styles/main.scss';
@import '~vue-skeletor/dist/vue-skeletor.css';

.backroute-module{
    width: fit-content;
    padding-left: 10px;
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: 600;
    font-size: 12px;
    color: $green;
    cursor: pointer;
    .material-icons{
        font-size: 17px;
    }
}

.module {
    .header-sticky{
        margin-bottom: 8px;
        margin-top: -8px;
        margin-left: -24px;
        margin-right: -24px;
        padding-top: 12px;
        position: sticky;
        top: 56px;
        background-color: #fff;
        z-index: 1500;
        box-shadow: 0 4px 2px -2px rgba(0, 0, 0, 0.1);
        @media screen and (max-width: 1000px){
            margin-left: -8px;
            margin-right: -8px;
            top: 45px;
            .backroute-module{
                padding: 6px 0 12px 0;
            }
        }
    }
    &__header {
        padding: 0 24px;
        padding-bottom: 12px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        //border-bottom: 2px solid #BDBDBD;
        h2 {
            color: $green;
        }

        div {
            text-align: center;
        }

        button {
            display: flex;
            align-items: center;
            font-family: 'Open Sans', sans-serif;
            font-weight: 700;
            color: $black;

            &:disabled {
                opacity: .5;
                cursor: default;
            }
        }
    }
    &__resume{
        width: 100%;
        padding: 12px 0;
        display: grid;
        grid-template-columns: auto auto;
        justify-content: center;
        gap: 24px;
        >div{
            width: fit-content;
            flex-grow: 1;
            display: flex;
            align-items: center;
            gap: 6px;
            font-weight: 600;
            span{
                color: $green;
            }
        }
    }
}

p.module-locked{
    font-size: 18px;
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 16px;
}

.status-message{
    margin-top: 8px;
    margin-bottom: 12px;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    span{
        font-size: 15px;
        font-weight: 600;
    }
    .material-icons{
        font-size: 22px;
    }
}

@media screen and (max-width: 1000px){
    .module__header{
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        padding: 12px 0;
        .previewNext{
            width: 100%;
            display: flex;
            justify-content: space-between;
        }
    }

    .module__resume{
        div{
            font-size: 12px;
        }
    }
}
</style>